import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  printers: [],
};

const printerSlice = createSlice({
  name: "printer",
  initialState,
  reducers: {
    addPrinter: (state, action) => {
      state.printers = action.payload;
    },
    removePrinter: (state) => {
      state.printers = []
    }
  },
});
export const {
    addPrinter,
    removePrinter
} = printerSlice.actions;
export default printerSlice.reducer;
